import ShareModal from "./share-modal";
export default ShareModal;
